import * as React from 'react';
import { connect } from 'react-redux';
import * as Sentry from '@sentry/browser';

type OwnProps = {};

type StateProps = {
  user: {
    uuid: string
  }
};

type Props = OwnProps & StateProps;

class SentryProvider extends React.PureComponent<Props> {
  render() {
    const { user } = this.props;

    if (user && user.uuid) {
      Sentry.configureScope(scope => {
        scope.setUser({ id: user.uuid });
      });
    }

    return null;
  }
}

const mapStateToProps = ({ account }): StateProps => ({
  user: account.currentAccount
});

export default connect(mapStateToProps)(SentryProvider);
